export const storagePrefixKey = '@vyoo/';

export const tokenKey = 'token';

export const tokenTypeKey = 'tokenType';

export const expiresAtKey = 'expiresAt';

export const userKey = 'user';
